import React from 'react';
import styled from 'styled-components';
import Button from './Button';

const ErrorContainer = styled.div`
  min-height: calc(100vh - 140px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: linear-gradient(to bottom, #f5f5f5 0%, #ffffff 100%);
`;

const ErrorContent = styled.div`
  text-align: center;
  max-width: 600px;
`;

const ErrorIcon = styled.div`
  font-size: 5rem;
  margin-bottom: 2rem;
  color: var(--primary-color);
`;

const ErrorTitle = styled.h1`
  font-size: 2.5rem;
  color: var(--text-dark);
  margin-bottom: 1rem;
`;

const ErrorMessage = styled.p`
  font-size: 1.1rem;
  color: var(--text-gray);
  margin-bottom: 2rem;
  line-height: 1.6;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer>
          <ErrorContent>
            <ErrorIcon>⚠️</ErrorIcon>
            <ErrorTitle>Oops! Something went wrong</ErrorTitle>
            <ErrorMessage>
              We're sorry, but something unexpected happened. 
              Please try refreshing the page or return to the home page.
            </ErrorMessage>
            <ButtonGroup>
              <Button onClick={this.handleReload} $variant="primary">
                Refresh Page
              </Button>
              <Button onClick={this.handleHome} $variant="secondary">
                Go to Home
              </Button>
            </ButtonGroup>
          </ErrorContent>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
